/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var RotateSquareLeftIcon20Solid = forwardRef('RotateSquareLeftIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11.368.225a1 1 0 0 1 1.264 1.55L12.356 2H14.5A4.5 4.5 0 0 1 19 6.5V9a1 1 0 1 1-2 0V6.5A2.5 2.5 0 0 0 14.5 4h-2.144l.276.225a1 1 0 0 1-1.264 1.55L9.724 4.433a1.85 1.85 0 0 1 0-2.866L11.368.225Z" }),
        React.createElement("path", { d: "M15 10.25A3.25 3.25 0 0 0 11.75 7h-5.5A3.25 3.25 0 0 0 3 10.25v5.5A3.25 3.25 0 0 0 6.25 19h5.5A3.25 3.25 0 0 0 15 15.75v-5.5Z" })));
});
